const Emitter = {
  _callbacks: {},
  register: function(name, fn, context) {
    if (!name) {
      return;
    }
    fn = fn || function() {};
    let list;
    if (!Emitter._callbacks[name]) {
      list = Emitter._callbacks[name] = [];
    } else {
      list = Emitter._callbacks[name];
    }
    if (list && Object.prototype.toString.call(list) == '[object Array]') {
      list.push({ fn: fn, context: context });
    }
  },
  trigger: function(name) {
    let lists = [];
    if (!name) {
      //触发所有
      for (let key in Emitter._callbacks) {
        lists.concat(Emitter._callbacks[key]);
      }
    } else {
      //触发指定
      lists = Emitter._callbacks[name];
    }
    if (!lists) return;
    for (let i = 0, len = lists.length; i < len; i++) {
      let list = lists[i];
      let _fn = list.fn;
      _fn.apply(list.context || this, [].slice.call(arguments, 1));
    }
  },
  unregister: function(name, fn) {
    let list, index;
    if (!name) {
      return;
    }
    if (!Emitter._callbacks[name]) {
      return;
    }
    list = Emitter._callbacks[name];
    // 若不传fn，认为取消该方法下所有订阅者
    if (!fn) {
      list.length = 0;
      return;
    }
    for (let i = 0; i < list.length; i++) {
      if (list[i].fn === fn) {
        index = i;
      }
    }
    if (index !== -1) {
      list.splice(index, 1);
    }
  },
};
// 兼容
if (!window.aliyun_global_observer) {
  window.aliyun_global_observer = Emitter;
}
export default Emitter;



// WEBPACK FOOTER //
// ./src/components/emitter.js